import React from "react";
import { Helmet } from "react-helmet-async";
import { useTranslation } from "react-i18next";

function TermsAndConditions() {
  const { t } = useTranslation();

  return (
    <div className="container mx-auto px-4 py-8">
      <Helmet>
        <title>{t("terms.pageTitle")}</title>
        <meta
          name="description"
          content={t("terms.metaDescription")}
        />
      </Helmet>

      <h1 className="text-3xl font-bold text-center mb-6">{t("terms.heading")}</h1>
      <p className="text-gray-600 text-center mb-8">
        {t("terms.intro")}
      </p>

      <div className="space-y-6">
        {t("terms.sections", { returnObjects: true }).map((section, index) => (
          <section key={index}>
            <h2 className="text-xl font-semibold">{section.title}</h2>
            {Array.isArray(section.body) ? (
              <ul className="list-disc list-inside text-gray-700">
                {section.body.map((item, i) => (
                  <li key={i}>{item}</li>
                ))}
              </ul>
            ) : (
              <p className="text-gray-700">{section.body}</p>
            )}
          </section>
        ))}
      </div>
    </div>
  );
}

export default TermsAndConditions;
